import { render, staticRenderFns } from "./edit-detail.vue?vue&type=template&id=80d93c14&scoped=true&"
import script from "./edit-detail.vue?vue&type=script&lang=js&"
export * from "./edit-detail.vue?vue&type=script&lang=js&"
import style0 from "./edit-detail.vue?vue&type=style&index=0&id=80d93c14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d93c14",
  null
  
)

export default component.exports